export default "__VITE_ASSET__f8249366__"